import { render } from "./OrganizationEditModal.vue?vue&type=template&id=a16744dc"
import script from "./OrganizationEditModal.vue?vue&type=script&lang=js"
export * from "./OrganizationEditModal.vue?vue&type=script&lang=js"

import "./OrganizationEditModal.vue?vue&type=style&index=0&id=a16744dc&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__